import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { AlertTriangle } from "lucide-react";
import { Panel, inputCls, labelCls, btnPrimary } from "./ui";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const FIELDS = [
  { k: "whatsapp", label: "WhatsApp de atendimento", ph: "(21) 99999-9999" },
  { k: "email", label: "E-mail de atendimento", ph: "contato@sehospedeaki.com.br" },
  { k: "instagram", label: "Instagram", ph: "@sehospedeaki" },
  { k: "company_name", label: "Nome da empresa / responsável", ph: "Se Hospede AKI Ltda." },
  { k: "cnpj", label: "CNPJ ou CPF (opcional)", ph: "00.000.000/0001-00" },
  { k: "combo_discount_percent", label: "Desconto combo casa + jet ski (%)", ph: "0 = sem desconto", type: "number" },
];

export const SiteSettingsSection = () => {
  const [f, setF] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => { axios.get(`${API}/public/site`).then((r) => setF(r.data)).catch(() => {}); }, []);

  const save = async () => {
    setSaving(true);
    try {
      const r = await axios.put(`${API}/site`, { ...f, combo_discount_percent: Number(f.combo_discount_percent || 0) });
      setF(r.data);
      toast.success("Dados do site atualizados.");
    } catch (e) {
      toast.error(e.response?.data?.detail?.[0]?.msg || e.response?.data?.detail || "Erro ao salvar");
    }
    setSaving(false);
  };

  return (
    <Panel id="site" title="Dados do site" subtitle="Contatos que aparecem no rodapé, nas políticas e no botão de WhatsApp." testId="site-settings-section">
      {!f.whatsapp && !f.email && (
        <div className="flex items-center gap-2 text-sm font-semibold rounded-2xl px-3 py-2.5 bg-amber-50 text-amber-800 mb-4" data-testid="site-contacts-missing">
          <AlertTriangle size={16} /> Preencha pelo menos um contato para os hóspedes falarem com você.
        </div>
      )}
      <div className="grid sm:grid-cols-2 gap-3">
        {FIELDS.map(({ k, label, ph, type }) => (
          <div key={k}>
            <label className={labelCls}>{label}</label>
            <input type={type || "text"} value={f[k] ?? ""} onChange={(e) => setF({ ...f, [k]: e.target.value })} placeholder={ph}
              className={inputCls} data-testid={`site-${k}`} />
          </div>
        ))}
      </div>
      <button onClick={save} disabled={saving} className={`${btnPrimary} mt-4`} data-testid="site-save">{saving ? "Salvando..." : "Salvar dados"}</button>
    </Panel>
  );
};
